module.exports = __webpack_public_path__ + "img/shoot_00001.654bd2ae.png";